type SubdomainUriProps = {
  altdomain: string;
  domain: string;
  subdomain: string;
  tld: string;
};

const subdomainUri = ({
  altdomain,
  domain,
  subdomain,
  tld,
}: SubdomainUriProps) => {
  if (subdomain !== 'www') {
    return `https://${altdomain}.${subdomain}.${domain}.${tld}`;
  }
  return `https://${altdomain}.${domain}.${tld}`;
};

export default subdomainUri;
export { subdomainUri };
